import React, {FC} from 'react'
import {KTSVG} from '../../../helpers'
import {Link} from 'react-router-dom'
import CountUp from 'react-countup'
import {RootState} from '../../../../setup'
import {shallowEqual, useSelector} from 'react-redux'
import {IWorkspaceState} from '../../../../app/@reducer/WorkspaceRedux'
import {CapitalizeFirstLetter} from '../../../../app/features'
import {Card2Type} from '../../../../app/@types'

const Card2: FC<Card2Type> = ({bg, iconPath, body, to}) => {

    const {
        colors: {
            primary,
            secondary,
            textColor
        },
    } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

    const backgroundColor = bg ? secondary : primary

    return (
        <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100"
             style={{backgroundColor: `${backgroundColor}d5`}}
        >
            {/*begin::Card Header*/}
            <div className="card-header p-5">
                {/*begin::Icon*/}
                <div className="d-flex flex-center rounded-circle h-40px w-40px"
                     style={{border: '1px dashed rgba(255, 255, 255, .6)', backgroundColor}}
                >
                    <KTSVG path={iconPath} className="svg-icon svg-icon-2 svg-icon-white" />
                </div>
                {/*end::Icon*/}
                {
                    to && (
                        <div className="card-toolbar d-flex align-items-start">
                            <Link to={to} className="btn btn-sm fw-bold" style={{backgroundColor, color: textColor}}>
                                Voir plus
                            </Link>
                        </div>
                    )
                }

            </div>
            {/*end::Card Header*/}


            {/*begin::Card Section1*/}
            <div className="card-body d-flex align-items-end p-5">
                {/*begin::Info*/}
                <div className="d-flex align-items-center" style={{color: textColor}}>
                    <span className="fs-2 fw-bold me-4">
                        <CountUp end={body.total === -1 ? 0 : body.total} duration={1.5} />
                    </span>
                    <div className="fw-bold fs-6">
                        <span className="d-block">{CapitalizeFirstLetter(body.text)}</span>
                    </div>
                </div>
                {/*end::Info*/}
            </div>
            {/*end::Card Section1*/}
        </div>
    )
}

export {Card2}
